import { render, staticRenderFns } from "./CredendialPolicialView.vue?vue&type=template&id=deb81f54&scoped=true&"
import script from "./CredendialPolicialView.vue?vue&type=script&lang=js&"
export * from "./CredendialPolicialView.vue?vue&type=script&lang=js&"
import style0 from "./CredendialPolicialView.vue?vue&type=style&index=0&id=deb81f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb81f54",
  null
  
)

export default component.exports